import {types as t} from 'mobx-state-tree';
import {SentenceCompleteAnswerQuestions} from './sentence-complete-question.store';

export const FlowChartAnswerQuestion = SentenceCompleteAnswerQuestions.named(
  'FlowChartAnswerQuestion',
).props({
  heading: t.maybeNull<any>(t.string),
});

